export { ProductAdder, ProductAdderRoot, ProductAdderHeader, ProductAdderBody } from './features/productAdder';

export type { ProductAdderStep } from './features/productAdder';

export { additionalsSelectionIsComplete } from './core/additionalsSelectionIsComplete';
export type {
  AdditionalsSelectionIsCompleteInput,
  ProductAdditionalFormSlice,
} from '@src/domains/products/core/additionalsSelectionIsComplete';
export { pickFirstScheduledProductId } from './core/pickFirstScheduledProductId';
export type { PackageProductForScheduling } from './core/pickFirstScheduledProductId';
export { ProductBooking } from './features/product-booking';
export { ProductUpsellModal } from './features/productUpsell/components/ProductUpsellModal';
export { default as UpsellBookingModal } from './features/productUpsell/components/UpsellBookingModal';
export { default as MultiProductBookingModal } from './features/multiProductBooking/MultiProductBookingModal';
export type { LanguageOption } from './features/product-booking';
export { getSelectedLanguageValue, getLanguageOptionMeta } from './features/product-booking';
export type { AttributeOption, SelectedProductAttribute, TariffGroupAttributeType } from './features/product-booking';
export { getNonLanguageSelectedAttributes, getAttributeTypeLabel } from './features/product-booking';
